import { useCallback } from 'react';

/**
 * Custom hook for Google reCAPTCHA v3
 * @param {string} action - The action name for this reCAPTCHA execution
 * @returns {Function} executeRecaptcha - Function to get reCAPTCHA token
 */
export const useRecaptcha = (action = 'submit') => {
  const executeRecaptcha = useCallback(async () => {
    try {
      // Check if reCAPTCHA is loaded
      if (!window.grecaptcha) {
        console.warn('reCAPTCHA not loaded yet');
        return null;
      }

      const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
      
      if (!siteKey || siteKey === 'your_recaptcha_site_key_here') {
        console.warn('reCAPTCHA site key not configured');
        return null;
      }

      // Execute reCAPTCHA and get token
      return new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
          try {
            const token = await window.grecaptcha.execute(siteKey, { action });
            resolve(token);
          } catch (error) {
            console.error('reCAPTCHA execution error:', error);
            resolve(null);
          }
        });
      });
    } catch (error) {
      console.error('reCAPTCHA error:', error);
      return null;
    }
  }, [action]);

  return executeRecaptcha;
};
